<template>
  <DragDialog
    :title="getTitle()"
    :width="588"
    :visible.sync="visible"
    :footerBtn="['submit', 'cancel']"
    :submit="submit"
    :cancel="cancel"
    class="inner-pop-primary">
    <div class="viewport-form-box">
      <el-form
        :model="viewportForm"
        :rules="rules"
        ref="viewportForm"
        class="public-form-primary"
        label-width="80px">
        <el-form-item
          label="视口名称："
          prop="name">
          <el-input
            size="small"
            class="input-primary"
            :maxlength="30"
            v-model="viewportForm.name"
            placeholder="请输入视口名称" />
        </el-form-item>
        <el-form-item>
          <template slot="label">
            <div class="form-label-box">视口描述：</div>
          </template>
          <el-input
            class="input-primary"
            v-model="viewportForm.description"
            autocomplete="off"
            placeholder="请输入视口描述"
            type="textarea"
            maxlength="100"
            rows="4"
            show-word-limit />
        </el-form-item>
        <el-form-item label="视口快照：">
          <div class="img-box">
            <img
              :src="viewportForm.imgSrc"
              v-if="viewportForm.imgSrc" />
          </div>
        </el-form-item>
        <!-- <el-form-item>
          <el-checkbox
            v-model="viewportForm.isSaveElemStatus"
            class="checkbox-primary"
          >
            保留构件显隐和透明状态
          </el-checkbox>
        </el-form-item> -->
      </el-form>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

import {
  createSceneViewportService,
  updateSceneViewportService
} from '@/service/interface'

export default {
  data() {
    return {
      viewportForm: {
        name: '',
        description: '',
        imgSrc: '',
        isSaveElemStatus: false
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入视口名称',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  props: {
    visible: Boolean,
    viewportInfo: Object,
    refreshViewportList: Function,
    closeDialog: Function
  },
  components: {
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    initData() {
      if (this.viewportInfo) {
        // prettier-ignore
        let { name, description, thumbnail, isPreserveComponentVisibilityAndTransparency } = this.viewportInfo;
        let timestamp = new Date().getTime()
        let imgSrc = `${window.imageBaseUrl}/${thumbnail}?timestamp=${timestamp}`
        let viewportForm = {
          name,
          description,
          imgSrc,
          isSaveElemStatus: isPreserveComponentVisibilityAndTransparency
        }
        this.viewportForm = viewportForm
      } else {
        this.createViewportImg()
      }
    },
    submit() {
      this.$refs.viewportForm.validate((bool, object) => {
        if (bool) {
          let sceneId = this.$route.query.sceneId
          let params = {
            sceneId,
            name: this.viewportForm.name,
            description: this.viewportForm.description
          }
          if (this.viewportInfo) {
            params.sceneViewPortId = this.viewportInfo.sceneViewPortId
            updateSceneViewportService(params).then(response => {
              if (response.isSuccess) {
                this.refreshViewportList().then(() => {
                  this.$message.success('修改视口成功')
                  this.clearForm()
                  this.closeDialog()
                })
              } else {
                this.$message.error(response.errMsg)
              }
            })
          } else {
            let imgSrc = this.viewportForm.imgSrc
            let base64Image = imgSrc.replace('data:image/png;base64,', '')
            params.base64Image = base64Image
            // prettier-ignore
            params.isPreserveComponentVisibilityAndTransparency = this.viewportForm.isSaveElemStatus;
            params.visualAngle = this.getViewAngle()
            createSceneViewportService(params).then(response => {
              if (response.isSuccess) {
                this.refreshViewportList().then(() => {
                  this.$message.success('添加视口成功')
                  this.clearForm()
                  this.closeDialog()
                })
              } else {
                this.$message.error(response.errMsg)
              }
            })
          }
        } else {
          this.$message.error('表单验证失败，请正确填写相关内容后再重新提交')
        }
      })
    },
    getViewAngle() {
      let camLocate = window.BlackHole3D.Camera.getCamLocate()
      let { camDir, camPos, camRotate } = camLocate
      camDir = camDir.map(el => Number(el.toFixed(6)))
      camPos = camPos.map(el => Number(el.toFixed(6)))
      camRotate = camRotate.map(el => Number(el.toFixed(6)))
      let visualAngleObj = { camDir, camPos, camRotate }
      let visualAngle = JSON.stringify(visualAngleObj)

      return visualAngle
    },
    cancel() {
      this.$confirm('您确定要放弃当前编辑吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.clearForm()
        this.closeDialog()
      })
    },
    clearForm() {
      this.viewportForm = {
        name: '',
        description: '',
        imgSrc: '',
        isSaveElemStatus: false
      }
    },
    async createViewportImg() {
      const BlackHole3D = window.BlackHole3D
      BlackHole3D.Graphics.setGeoCoordVisible(false)
      BlackHole3D.Graphics.setViewCubeVisible(false)
      BlackHole3D.Graphics.setSysUIPanelVisible(false)

      await this.sleep(100)

      let imgSrc = BlackHole3D.getScreenSnapshot()
      this.viewportForm.imgSrc = imgSrc
      BlackHole3D.Graphics.setGeoCoordVisible(true)
      BlackHole3D.Graphics.setViewCubeVisible(true)
      BlackHole3D.Graphics.setSysUIPanelVisible(true)
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    getTitle() {
      let title = this.viewportInfo ? '编辑视口' : '新建视口'
      return title
    }
  }
}
</script>

<style lang="less" scoped>
.viewport-form-box {
  .public-form-primary {
    :deep(.el-form-item) {
      &:last-child {
        margin-bottom: 0px;

        .el-form-item__content {
          line-height: 0px;
        }
      }

      .el-form-item__label {
        padding: 0px;

        &::before {
          margin-right: 2px;
        }
      }

      .form-label-box {
        line-height: 15px;
      }

      .img-box {
        height: 270px;
        border-radius: 17px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 17px;
          object-fit: cover;
        }
      }
    }
  }
}
</style>
